// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aa336ed7","239":"7ae8c518","732":"2fbf7524"}[chunkId] + ".chunk.js";
};